module.exports = __webpack_public_path__ + "img/TrendingEvents4.ba03b614.jpg";